module.exports = __webpack_public_path__ + "img/tour-6.0c98067b.png";